import React from 'react';
import { Box, Paper, Typography, Divider, Grid } from '@mui/material';

const AverageGradeCard = ({ listData = [] }) => {
  const calculateMetrics = (data) => {
    // 1. Filter out unwanted rows
    const filteredData = data.filter((item) => item.rating !== 'To be done' && item.rating !== 'Total');

    let totalScore = 0;
    let totalCount = 0;

    // 2. No weights → each rating counts equally
    filteredData.forEach((item) => {
      totalScore += item.count;
      totalCount += item.count;
    });

    // 3. Raw average
    const avg = totalCount > 0 ? totalScore / filteredData.length : 0;

    // 4. Objective rating (same formatting rule)
    const objective = Math.ceil(avg * 100) / 100 + 0.01;

    // 5. Grade logic (unchanged)
    let grade = 'E';
    if (avg <= 0.7) grade = 'S';
    else if (avg <= 0.95) grade = 'A';
    else if (avg <= 1.25) grade = 'B';
    else if (avg <= 1.75) grade = 'C';
    else grade = 'D';

    return {
      averageGrade: grade,
      averageRating: avg.toFixed(3),
      objectiveRating: objective.toFixed(2).replace('.', ','),
    };
  };

  const { averageGrade, averageRating, objectiveRating } = calculateMetrics(listData);

  return (
    <Paper elevation={3} sx={{ p: 3, borderRadius: 4, textAlign: 'center' }}>
      <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
        {averageGrade}
      </Typography>

      <Typography variant="body2" color="text.secondary">
        Average grade
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="h5" color="primary">
            {averageRating}
          </Typography>
          <Typography variant="caption">Average rating</Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography variant="h5" color="primary">
            {objectiveRating}
          </Typography>
          <Typography variant="caption">Objective rating</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AverageGradeCard;
